import React from 'react';
import { func } from 'prop-types';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import style from './style';

const Presenter = ({onClickTerms,onCLickPrivacyPolicy,t}) =>{

	return (
		<style.Wrapper>
			<div>
				<style.Link href='https://forms.gle/1P9aoDLxPnX9Nk5e7' target='_blank'>
					{t('footer.Contact')}
				</style.Link>
			</div>
			<style.Divider>|</style.Divider>
			<div>
				<style.Link onClick={onCLickPrivacyPolicy}>
					{t('footer.PrivacyPolicy')}
				</style.Link>
			</div>
			<style.Divider>|</style.Divider>
			<div>
				<style.Link onClick={onClickTerms}>
					{t('footer.Terms')}
				</style.Link>
			</div>
		</style.Wrapper>
	);
};

Presenter.propTypes = {
	onCLickPrivacyPolicy : func.isRequired,
	onClickTerms : func.isRequired,
	t : func.isRequired
};

export default withNamespaces()(Presenter);
